import { useState, useEffect } from 'react'
import { registerUser, getEquipos, getTiposUsuario } from '../api/apiConfig'
import { chileLocalDigits, chileMobileCompleto, chileMobileDigits, formatChileMobile } from '../utils/phoneChile'

const EMPTY_FORM = {
  nombre: '',
  email: '',
  password: '',
  telefono: '',
  tipo_usuario: '',
  tipo_ejecutivo: '',
  grupo: '',
  sucursal: '',
  ejec_sis_fact: '',
  fecha_ingreso: ''
}

const NuevoUsuario = ({ embedded = false, onCreated, onCancel }) => {
  const [formData, setFormData] = useState({ ...EMPTY_FORM })
  const [equipos, setEquipos] = useState([])
  const [tiposUsuario, setTiposUsuario] = useState([])
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')

  useEffect(() => {
    const loadSelectData = async () => {
      try {
        const [equiposData, tiposData] = await Promise.all([
          getEquipos(),
          getTiposUsuario()
        ])
        
        console.log('Equipos data:', equiposData)
        console.log('Tipos data:', tiposData)
        
        // Manejar diferentes formatos de respuesta
        const equiposArray = Array.isArray(equiposData) ? equiposData : 
                           equiposData?.data || equiposData?.equipos || []
        const tiposArray = Array.isArray(tiposData) ? tiposData : 
                          tiposData?.data || tiposData?.tipos || []
        
        console.log('Equipos array:', equiposArray)
        console.log('Tipos array:', tiposArray)
        
        setEquipos(equiposArray)
        setTiposUsuario(tiposArray)
      } catch (error) {
        console.error('Error cargando datos:', error)
        // Datos de fallback
        setEquipos([
          { id: 'comercial', nombre: 'Equipo Comercial' },
          { id: 'tecnico', nombre: 'Equipo Técnico' },
          { id: 'administracion', nombre: 'Administración' },
          { id: 'factoring', nombre: 'Sistema Factoring' }
        ])
        setTiposUsuario([
          { id: 'admin', nombre: 'Administrador' },
          { id: 'usuario', nombre: 'Usuario' },
          { id: 'supervisor', nombre: 'Supervisor' },
          { id: 'ejecutivo', nombre: 'Ejecutivo' }
        ])
      }
    }
    loadSelectData()
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: name === 'telefono' ? formatChileMobile(value) : value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage('')

    const hasPhoneDigits = chileLocalDigits(formData.telefono).length > 0
    if (hasPhoneDigits && !chileMobileCompleto(formData.telefono)) {
      setMessage('El teléfono debe tener 8 dígitos (56 9 1234 5678) o quedar vacío')
      setLoading(false)
      return
    }

    try {
      const result = await registerUser({
        ...formData,
        telefono: hasPhoneDigits ? chileMobileDigits(formData.telefono) : ''
      })
      if (result.success) {
        setMessage('Usuario creado exitosamente')
        setFormData({ ...EMPTY_FORM })
        onCreated?.()
      } else {
        setMessage(result.message || 'Error al crear usuario')
      }
    } catch (error) {
      setMessage('Error al crear usuario')
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
      <div className={embedded ? '' : 'p-6'}>
        {!embedded && (
          <div className="flex items-baseline gap-4 mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Nuevo usuario</h1>
          </div>
        )}
      
      <div className={embedded ? '' : 'bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6'}>
        {!embedded && (
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Crear nuevo usuario</h2>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nombre
            </label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Teléfono <span className="font-normal text-gray-400">(opcional)</span>
            </label>
            <input
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              onFocus={() => setFormData((prev) => ({ ...prev, telefono: formatChileMobile(prev.telefono) }))}
              inputMode="tel"
              maxLength={14}
              placeholder="56 9 1234 5678"
              autoComplete="tel"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Contraseña
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tipo de Usuario
            </label>
            <select
              name="tipo_usuario"
              value={formData.tipo_usuario}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            >
              <option value="">Seleccionar tipo</option>
              {tiposUsuario.map((tipo, index) => (
                <option key={tipo.usuario || index} value={tipo.usuario}>
                  {tipo.usuario}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tipo Ejecutivo
            </label>
            <select
              name="tipo_ejecutivo"
              value={formData.tipo_ejecutivo}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            >
              <option value="">Seleccionar tipo ejecutivo</option>
              <option value="Agente-Empresa">Agente-Empresa</option>
              <option value="Digital">Digital</option>
              <option value="Pyme">Pyme</option>
              <option value="Otros">Otros</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Equipo
            </label>
            <select
              name="grupo"
              value={formData.grupo}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            >
              <option value="">Seleccionar equipo</option>
              {equipos.map((equipo, index) => (
                <option key={equipo.equipo || equipo.usuario || index} value={equipo.equipo || equipo.usuario}>
                  {equipo.equipo || equipo.usuario}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Sucursal
            </label>
            <select
              name="sucursal"
              value={formData.sucursal}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            >
              <option value="">Seleccionar sucursal</option>
              <option value="Antofagasta">Antofagasta</option>
              <option value="Calama">Calama</option>
              <option value="Concepción">Concepción</option>
              <option value="Copiapó">Copiapó</option>
              <option value="Digital">Digital</option>
              <option value="Iquique">Iquique</option>
              <option value="La Serena">La Serena</option>
              <option value="Normalización">Normalización</option>
              <option value="Puerto Montt">Puerto Montt</option>
              <option value="Punta Arenas">Punta Arenas</option>
              <option value="Rancagua">Rancagua</option>
              <option value="Santiago">Santiago</option>
              <option value="Talca">Talca</option>
              <option value="Temuco">Temuco</option>
              <option value="Viña del Mar">Viña del Mar</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Ejecutivo Sistema Factoring
            </label>
            <input
              type="text"
              name="ejec_sis_fact"
              value={formData.ejec_sis_fact}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Fecha de Ingreso
            </label>
            <input
              type="date"
              name="fecha_ingreso"
              value={formData.fecha_ingreso}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>

          <div className={embedded ? 'flex gap-2 justify-end' : ''}>
            {embedded && onCancel && (
              <button
                type="button"
                onClick={onCancel}
                disabled={loading}
                className="px-3 py-2 text-sm border rounded-lg"
              >
                Cancelar
              </button>
            )}
            <button
              type="submit"
              disabled={loading}
              className={
                embedded
                  ? 'px-3 py-2 text-sm rounded-lg bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-50 disabled:cursor-not-allowed'
                  : 'w-full bg-teal-600 text-white py-2 px-4 rounded-md hover:bg-teal-700 disabled:opacity-50 disabled:cursor-not-allowed'
              }
            >
              {loading ? 'Creando...' : 'Crear Usuario'}
            </button>
          </div>
        </form>

        {message && (
          <div className={`mt-4 p-3 rounded ${message.includes('exitosamente') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  )
}

export default NuevoUsuario